import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import { useSvgId } from '../../primitives/useSvgId.js';
import type { IconProps } from '../../primitives/types.js';

/** @ mention — a particle orbits the outer ring, tracing the "at" symbol.
 *  Uses <animateMotion> with an mpath so the dot follows an ellipse
 *  mathematically, instead of a hand-authored keyframe list. */
export function IcnAt(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  const pathId = useSvgId('at-orbit');
  return (
    <Svg {...props} iconName="at">
      <defs>
        <path id={pathId} d="M14 8a6 6 0 1 1 -12 0a6 6 0 0 1 12 0z" fill="none" />
      </defs>
      <circle cx="8" cy="8" r="6" />
      <circle cx="8" cy="8" r="2" />
      <path d="M10 8v1.5a1.5 1.5 0 0 0 3 0V8" />
      {animate && (
        <circle r="0.6" fill="currentColor" stroke="none">
          <animateMotion dur="4.5s" repeatCount="indefinite">
            <mpath xlinkHref={`#${pathId}`} />
          </animateMotion>
        </circle>
      )}
    </Svg>
  );
}
